import { FilterChoice } from '../../types/FilterChoice';
import { SuggestionData } from '../types';

export const suggestionsFromFilters = (sortedFilters: FilterChoice[]): SuggestionData[] =>
  sortedFilters.map(filter => ({
    type: 'FilterSuggestion' as const,
    id: `specialty-${filter.topic?.specialist}-${filter.topic?.treatment}-${filter.location?.suburb?.name}-${filter.location?.suburb?.postcode}`,
    filters: filter,
  }));
